import React from "react";
import { useTranslation } from "react-i18next";
import { Button, styled } from "@mui/material";

const ButtonCustom = styled(Button)(({ theme }) => ({
  fontFamily: "Patua One",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "24px",
  textAlign: "center",
  display: "block",
  width: "100%",
  textTransform: "none",
  backgroundColor: "#46AA71",
  padding: "1rem",
  "&:hover": {
    backgroundColor: "#459b6a",
  },
  [theme.breakpoints.up("md")]: {
    maxWidth: "350px",
  },
}));

const ButtonPay = ({ refButton, onclick, ...props }) => {
  const { t } = useTranslation();

  return (
    <ButtonCustom ref={refButton} {...props} onClick={onclick}>
      {t("ppp.btn.continue")}
    </ButtonCustom>
  );
};

export default ButtonPay;
